import Workflow from "../sgiFlow/Workflow/Workflow";
import FlowEdit from "../sgiFlow/Workflow/FlowEdit";
import ServiceInterface from "../sgiFlow/SIDef/ServiceInterface";
import SICondition from "../sgiFlow/SIDef/SICondition";
import { SgiDV } from "../sgiComp/SgiDV";
import { SketchPicker } from 'react-color'
import G6Flow from "../sgiFlow/G6Flow/G6Flow"
import echarts from 'echarts/lib/echarts';

let sgiCustomModule = {
    Workflow: Workflow,
    ServiceInterface: ServiceInterface,
    SICondition: SICondition,
    FlowEdit: FlowEdit,

    // DV,TV(预览使用)
    SgiDV: SgiDV,
    sgiEcharts:echarts,
    // 颜色选择器
    SketchPicker,

    G6Flow: G6Flow
};

if (!window.sgiCustomModule) window.sgiCustomModule = {};
Object.assign(window.sgiCustomModule, sgiCustomModule);
export default window.sgiCustomModule;


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiConstants/sgiCustomModule.js